import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { Modal,  Button } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import { editUser } from '../../login/reducers/manageLogin'
import { handleErrorFetchingData } from '../../../functions/errorHandling'


class NewUserAlreadyExistsModal extends Component {

  state = {
    selectedClients: []
  }

  handleChangeClients = (selectedClients) => this.setState({ selectedClients })

  editUserClients = () => {
    const { user } = this.props

    swal({
      text: "Saving user's clients...",
      icon: require("../../../static/images/spinner.gif"),
      button: false
    })

    const selectedClientUrls = this.state.selectedClients.map(client => client.url)

    const clients = [...user.clients, ...selectedClientUrls]

    axios({
      method:"PATCH",
      url: user.url,
      headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
      data: { clients },
    })
    .then(response => {
      swal({
        title: "Success",
        text: "The user's clients have been updated",
        icon: "success",
        button: "Continue",
      })
      this.props.editUser(response.data)
      this.props.handleClose()
    })
    .catch(error => {
      const message = "There was an error editing the user's clients"
      handleErrorFetchingData(error, message)
    })
  }

  render() {
    const { show, user, handleClose } = this.props

    const { selectedClients } = this.state

    let clientOptions, userClients

    if (user && user.id) {
      clientOptions = this.props.clients.filter(client => !user.clients.includes(client.url))

      userClients = user.clients.map(clientUrl => {
        const client = this.props.clients.find(client => client.url === clientUrl)

        return (
          <li key={clientUrl}>
            {client.name} {client.short_code}
          </li>
        )
      })
    }

    return (
      <Modal show={show}>
        <Modal.Header closeButton onHide={handleClose}>
          <Modal.Title>
            User Already Exists
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {user && user.id ?
            <Fragment>
              <p>
                A user with this username or email already exists
              </p>

              <p>
                First Name: <strong>{user.first_name} </strong>
              </p>

              <p>
                Last Name: <strong>{user.last_name} </strong>
              </p>

              <p>
                Email: <strong>{user.email} </strong>
              </p>

              <p>
                Username: <strong>{user.username}</strong>
              </p>

              {user.clients.length > 0 ?
                <Fragment>
                  <br/>

                  <p>
                    This user has access to the following clients:
                  </p>

                  <ul id='user-already-exists-client-list'>
                    {userClients}
                  </ul>

                  <br/>

                  <p>
                    Would you like to give this user access to additional client PTORs?
                  </p>
                </Fragment>
                :
                <Fragment>
                  <p>
                    This user does not have access to any clients. Would you like to give them access to client PTORs?
                  </p>
                </Fragment>
              }

              <Typeahead
                id='ChangeUserClientsTypeahead'
                multiple
                labelKey={client => `${client.name} ${client.short_code}`}
                options={clientOptions}
                selected={selectedClients}
                onChange={this.handleChangeClients}
                placeholder="Select clients"
              />
            </Fragment>
            :
            null
          }
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleClose}>
            Cancel
          </Button>

          <Button onClick={this.editUserClients}>
            Edit User's Clients
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    clients: state.manageLogin.clients,
  }
}

export default connect(mapStateToProps, { editUser })(NewUserAlreadyExistsModal)



// WEBPACK FOOTER //
// ./src/routes/manager/components/NewUserAlreadyExistsModal.js